<template>
    <header class="header">
        <div class="logo">
            <!-- <img src="../assets/logo_title.png" alt="logo" /> -->
            <img src="../assets/logo_xinjin.jpg" alt="logo" />
        </div>
        <p class="tips">* 支持单人跨平台累计计算，计算结果仅供参考，请以导入后个税预计算结果为准</p>
        <h3 class="title">2025新规灵工平台收入计算器</h3>
    </header>
</template>